import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  popper: {
    zIndex: 1301,
  },
  paper: {
    marginTop: theme.spacing(0.5),
    borderRadius: 3,
    backgroundColor: '#FAFAFA',
    color: 'rgba(0,0,0,0.54)',
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minWidth: 400,
  },
  treeContainer: {
    overflowY: 'auto',
    maxHeight: 485,
    '& > div': {
      border: 'none',
    },
  },
  clearIcon: (props: { showTree?: boolean }) => ({
    visibility: 'hidden',
    '.hierarchy-text-field:hover &': {
      visibility: props.showTree ? 'hidden' : 'visible',
    },
  }),
}));
